/**
 * X (formerly Twitter) brand mark. Lucide-react still ships the legacy
 * bird as `Twitter`, which is now visually outdated — X rebranded in
 * July 2023. This component renders the official X letterform as inline
 * SVG so it composes with Lucide's sizing/color props without dragging
 * in another icon library.
 *
 * Props match Lucide's icon contract (size, className, strokeWidth)
 * so it's a drop-in replacement anywhere we currently render <Twitter />.
 */

interface XLogoProps {
  size?: number;
  className?: string;
  /** Accepted for API parity with Lucide icons; X mark renders as
   *  filled paths, not strokes, so this prop is intentionally ignored. */
  strokeWidth?: number;
}

export const XLogo = ({ size = 24, className }: XLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    className={className}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
